import { SelectWithAll } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Form, SelectProps } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { getDowntimeProps } from "../../../../../tickets";
import { PathContext } from "../../../context/PathContext";
import { FormItemPath } from "../../../types/Config";

type Props = {};

export const DowntimeFieldSelect = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);
  const { thresholds, getDowntimeLabelByValue } = getDowntimeProps();

  const options: SelectProps["options"] = useMemo(
    () =>
      thresholds.map((threshold) => ({
        label: t(getDowntimeLabelByValue(threshold)),
        value: threshold,
      })),
    []
  );

  return (
    <Form.Item<FormItemPath<"priority">>
      name={[...path, "downtime"]}
      label={t("maintenance:ticket.create.config.priority.downtime.label")}
      initialValue={thresholds}
    >
      <SelectWithAll
        allLabel={t("maintenance:general.all")}
        options={options}
      />
    </Form.Item>
  );
});
